module.exports = __webpack_public_path__ + "img/AN.d95dbf7b.svg";